export const API_FEES_SERVICE_TOKEN =
  process.env.REACT_APP_API_FEES_SERVICE_TOKEN || "";
export const EMPLOYER_APP_BASE_URL =
  process.env.REACT_APP_EMPLOYER_APP_BASE_URL || "";
export const START_INDEX = 0;
export const INDEX_OFFSET = 1;
export const NOT_FOUND_INDEX = -1;
export const REGISTERED_BUSINESS_COMPANY_TYPE = "registered business";
export const UNREGISTERED_BUSINESS_COMPANY_TYPE =
  "freelance business (not registered)";
export const PREVIOUS_HISTORY_INDEX = -1;
export const ZERO = 0;
export const ONE = 1;
export const THREE = 3;
export const NINE = 9;
export const TWO_DECIMAL_PLACES = 2;
export const EP_POPUP_CONTAINER = "ep-popup-container";
export const REACT_QUERY_IMMEDIATE_STALE_TIME = 0;
export const EMPTY_DATA_LENGTH = 0;
export const ONE_NAIRA_IN_KOBO = 100;
export const SEARCH_DEBOUNCE_TIMER = 1000;
export const TABLE_SCROLL_TO_TOP_OFFSET = 200;
export const NO_EXPORT_DATA_FOUND = "No data found for selected date range";
export const NO_NEW_FILTER_MESSAGE = "No new filter was added!";
export const POPUP_WRAPPER_ZINDEX = 1500;
export const SPLIT_SECOND = 500;
export const NUMBER_OF_MILLISECONDS = 1000;
export const NUMBER_OF_SECONDS = 60;
export const NUMBER_OF_MINUTES = 60;
export const NUMBER_OF_HOURS = 24;
export const HALF_A_SECOND = 30;
